import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import { fetchDiscountsBreakdownReport } from './actions';
import { t } from '../../../../modules/infra/i18n';

export default compose(
  connect(
    null,
    {
      fetchReport: fetchDiscountsBreakdownReport,
    }
  ),
  withProps(() => ({
    title: t('reports:breakdown.discounts'),
    csvJobName: 'discounted-breakdown-report',
  })),
);
